var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.224 18.2435H7.75L19.4479 6.54557C20.3698 5.6237 20.3698 4.1237 19.4479 3.20182L16.9375 0.691406C16.0156 -0.230469 14.5156 -0.230469 13.5938 0.691406L0.276042 13.9987C0.0989583 14.1758 0 14.4206 0 14.6706V19.1914C0 19.7122 0.421875 20.1341 0.942708 20.1341H5.03125H24.224C24.7448 20.1341 25.1667 19.7122 25.1667 19.1914C25.1667 18.6706 24.7448 18.2487 24.224 18.2487V18.2435ZM14.9219 2.02995C15.1094 1.84245 15.4062 1.84245 15.5938 2.02995L18.1042 4.54036C18.2917 4.72786 18.2917 5.02474 18.1042 5.21224L15.7604 7.55599L12.5781 4.3737L14.9219 2.02995ZM1.89062 15.0612L11.2396 5.70703L14.4219 8.88932L5.07292 18.2383H1.89062V15.056V15.0612Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit_pencil.00d3e0fc3a6e35d74d41625805e28255.svg";
export { ForwardRef as ReactComponent };